import { useEffect, useState } from "react"
import DemandPieChart from "./DemandPieChart"

const initialTrendGroups = {
  SILHOUETTE: [],
  COLORPATTERN: [],
  ATTRIBUTES: [],
  TEXTURE: [],
  LENGTH: [],
  NECKLINE: []
}
const createTrendGroups = (trends) => {
  const groups = {
    SILHOUETTE: [],
    COLORPATTERN: [],
    ATTRIBUTES: [],
    TEXTURE: [],
    LENGTH: [],
    NECKLINE: []
  }
  trends.forEach(trend => {
    if (trend.trendType == "SILHOUETTE") {
      groups.SILHOUETTE.push(trend)
    } else if (trend.trendType == "COLOR & PATTERN") {
      groups.COLORPATTERN.push(trend)
    } else if (trend.tag == "TEXTURES") {
      groups.TEXTURE.push(trend)
    } else if (trend.tag == 'TOP LENGTH' || trend.tag == 'BOTTOM LENGTH') {
      groups.LENGTH.push(trend)
    } else if (trend.tag == "NECKLINE") {
      groups.NECKLINE.push(trend)
    } else {
      groups.ATTRIBUTES.push(trend)
    }
  })

  return groups
}

const ChartsDisplay = ({ trends, unitsToSell, setShowImagesPopup, sort }) => {
  const [scoreKey, setScorekey] = useState('score15days_75_rog')
  const [trendGroups, setTrendGroups] = useState(initialTrendGroups)

  useEffect(() => {
    const newGroups = createTrendGroups(trends)
    setTrendGroups(newGroups)
  }, [trends])

  return <div className="w-full flex flex-wrap ">

    <DemandPieChart
      trends={trendGroups.SILHOUETTE}
      scoreKey={scoreKey}
      chartLabel="SILHOUETTE Trends"
      unitsToSell={unitsToSell}
      setShowImagesPopup={setShowImagesPopup}
    />


    <DemandPieChart
      trends={trendGroups.COLORPATTERN}
      scoreKey={scoreKey}
      chartLabel="COLOR & PATTERN Trends"
      unitsToSell={unitsToSell}
      setShowImagesPopup={setShowImagesPopup}
    />


    <DemandPieChart
      trends={trendGroups.ATTRIBUTES}
      scoreKey={scoreKey}
      chartLabel="ATTRIBUTE Trends"
      unitsToSell={unitsToSell}
      setShowImagesPopup={setShowImagesPopup}
    />

    <DemandPieChart
      trends={trendGroups.LENGTH}
      scoreKey={scoreKey}
      chartLabel="Top & BOTTOM LENGTH Trends"
      unitsToSell={unitsToSell}
      setShowImagesPopup={setShowImagesPopup}
    />

    <DemandPieChart
      trends={trendGroups.NECKLINE}
      scoreKey={scoreKey}
      chartLabel="NECKLINE Trends"
      unitsToSell={unitsToSell}
      setShowImagesPopup={setShowImagesPopup}
    />

    <DemandPieChart
      trends={trendGroups.TEXTURE}
      scoreKey={scoreKey}
      chartLabel="TEXTURE Trends"
      unitsToSell={unitsToSell}
      setShowImagesPopup={setShowImagesPopup}
    />


  </div>

}

export default ChartsDisplay
